var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('h1',[_vm._v("This is an login page")]),_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/"}},[_vm._v("Entrar")]),_c('h1',{on:{"click":function($event){return _vm.goTo('/')}}},[_vm._v("\n      Autenticado, vá pra home.\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }